import { UpdateScheduleAvailabilityInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateScheduleAvailabilityInputSchema: z.ZodType<UpdateScheduleAvailabilityInput> =
  z.object({
    imediate: z.number().int(),
    first_appointment: z.number().int(),
    partnerships: z.number().int(),
    block_agenda: z.number().int(),
    online: z.number().int(),
  });
